import * as React from 'react'
import "./../../style/dashboardPop.module.css"
declare let stAnalytics: any;
type Props = {
    // docType:string
    show: boolean,
    oncloseClicked: () => void,
    docType: string
}

const DashboardPopup = (props: Props) => {
    let docs = "/docs/guides"
    if (props.docType === 'COMMERCIAL_TRIAL' || props.docType === 'COMMERCIAL') {
        docs = "/docs/pro/getting-started/installation"
    }
    const sendAnalyticsOnClick = (eventName: string, href?: string) => {
        stAnalytics.getInstance().sendButtonEvent(eventName);
        if (href) {
            setTimeout(function () {
                window.open(href, "_blank");
            }, 100)
        }
    }

    if (props.show) {
        stAnalytics.getInstance().sendPageViewEventToSegment('page_dashboard_postdownload_nextsteppopup')
        return (
            <div className="dashpopup-main">
                <div className="dashpopup-main-content">
                    <div className="fist-half">
                        <div className="cancel-button">
                            <div className="cancel-button-main" onClick={() => { sendAnalyticsOnClick('button_postdownload_nextsteppopup_close'); props.oncloseClicked() }}>
                                <img src="/static/assets/popup_close.png" />
                            </div>
                        </div>
                        <h2 className="text-center bold">Super!</h2>
                        <p className="text-center">Thank you for downloading SuperTokens</p>
                    </div>
                    <div className="second-half">
                        <p>For help getting started, please click <i><a onClick={() => sendAnalyticsOnClick('button_postdownload_nextsteppopup_clickhere', docs)} >here</a></i> to check our documentation regarding the next steps.</p>
                        <p> To support our library, please star it on Github <a onClick={() => sendAnalyticsOnClick('button_postdownload_nextsteppopup_stargithub', 'https://github.com/supertokens/supertokens-core')} > <img className="img-github" src="/static/assets/star_github.png"></img></a></p>
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <div>
            </div>
        )
    }
}

export default DashboardPopup